import React, { useState, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./RichTextEditor.scss"; // Importar el archivo CSS
import { Box, useTheme } from "@mui/material";

export const RichTextEditor = ({
  label,
  value = "",
  onChange = () => {},
  placeholder = "",
  justView = false,
  isValid = null,
}) => {
  const theme = useTheme();
  const [uuid] = useState(crypto.randomUUID());
  const quillRef = useRef(null);

  const readOnly = justView;

  const modules = {
    toolbar: {
      container: `.custom-react-quill-toolbar-${uuid}`,
    },
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
      }}
    >
      <div
        className={`react-quill-rich-text-editor ${
          isValid === true ? "valid" : isValid === false ? "invalid" : ""
        } ${justView ? "just-view" : ""}`}
      >
        <div
          className={`custom-react-quill-toolbar-${uuid} ${
            justView ? "d-none" : ""
          }`}
        >
          {label && <span className="response-word">{`${label}   |  `}</span>}
          <span className="ql-formats">
            <button className="ql-bold"></button>
            <button className="ql-italic"></button>
            <button className="ql-underline"></button>
          </span>
          <span className="ql-formats">
            <button className="ql-align" value=""></button>
            <button className="ql-align" value="center"></button>
            <button className="ql-align" value="right"></button>
          </span>
          <span className="ql-formats">
            <button className="ql-list" value="bullet"></button>
          </span>
        </div>
        <ReactQuill
          ref={quillRef}
          className={`${justView ? "just-view" : ""}`}
          theme="snow"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          modules={modules}
          readOnly={readOnly}
        />
      </div>
    </Box>
  );
};
